import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { NebulaPlugin } from './nebula-plugin';
export var NebulaLogicenginePlugin = function (_NebulaPlugin) {
    _inherits(NebulaLogicenginePlugin, _NebulaPlugin);

    function NebulaLogicenginePlugin() {
        _classCallCheck(this, NebulaLogicenginePlugin);

        return _possibleConstructorReturn(this, (NebulaLogicenginePlugin.__proto__ || Object.getPrototypeOf(NebulaLogicenginePlugin)).apply(this, arguments));
    }

    _createClass(NebulaLogicenginePlugin, [{
        key: 'getBaseInfo',
        value: function getBaseInfo(mac, callback) {
            window.AlipayJSBridge.call('getBaseInfo', { deviceId: mac }, this.generateCallbackFunc(callback, this.convertLEBaseInfoFrom));
        }
    }, {
        key: 'getInitialAttributeList',
        value: function getInitialAttributeList(mac, callback) {
            window.AlipayJSBridge.call('getInitialAttributeList', { deviceId: mac }, this.generateCallbackFunc(callback, this.convertLEAttributeListFrom));
        }
    }, {
        key: 'getAttributeList',
        value: function getAttributeList(mac, callback) {
            window.AlipayJSBridge.call('getAttributeList', { deviceId: mac }, this.generateCallbackFunc(callback, this.convertLEAttributeListFrom));
        }
    }, {
        key: 'getAttributeByName',
        value: function getAttributeByName(mac, attrName, callback) {
            window.AlipayJSBridge.call('getAttributeByName', { deviceId: mac, name: attrName }, this.generateCallbackFunc(callback, this.convertLEAttributeFrom));
        }
    }, {
        key: 'getCautionList',
        value: function getCautionList(mac, callback) {
            window.AlipayJSBridge.call('getCautionList', { deviceId: mac }, this.generateCallbackFunc(callback, this.convertLECautionListFrom));
        }
    }, {
        key: 'attach',
        value: function attach(mac, deviceChangeListener, callback) {
            document.container.addEventListener('onUplusReportLogicConnection', function (result) {
                var deviceId = result === null || result === void 0 ? void 0 : result.mac;
                var baseInfo = result === null || result === void 0 ? void 0 : result.baseInfo;
                if (mac === deviceId) {
                    deviceChangeListener(deviceId, baseInfo);
                }
            });
            document.container.addEventListener('onUplusReportLogicOnlineStateV2', function (result) {
                var deviceId = result === null || result === void 0 ? void 0 : result.mac;
                var baseInfo = result === null || result === void 0 ? void 0 : result.baseInfo;
                if (mac === deviceId) {
                    deviceChangeListener(deviceId, baseInfo);
                }
            });
            document.container.addEventListener('onUplusReportLogicBleState', function (result) {
                var deviceId = result === null || result === void 0 ? void 0 : result.mac;
                var baseInfo = result === null || result === void 0 ? void 0 : result.baseInfo;
                if (mac === deviceId) {
                    deviceChangeListener(deviceId, baseInfo);
                }
            });
            document.container.addEventListener('onUplusReportLogicAttributes', function (result) {
                var deviceId = result === null || result === void 0 ? void 0 : result.mac;
                var baseInfo = result === null || result === void 0 ? void 0 : result.baseInfo;
                var attributes = result === null || result === void 0 ? void 0 : result.attributes;
                if (mac === deviceId) {
                    deviceChangeListener(deviceId, baseInfo, attributes);
                }
            });
            document.container.addEventListener('onUplusReportLogicCaution', function (result) {
                var deviceId = result === null || result === void 0 ? void 0 : result.mac;
                var baseInfo = result === null || result === void 0 ? void 0 : result.baseInfo;
                var attributes = result === null || result === void 0 ? void 0 : result.attributes;
                var cautions = result === null || result === void 0 ? void 0 : result.cautions;
                if (mac === deviceId) {
                    deviceChangeListener(deviceId, baseInfo, attributes, cautions);
                }
            });
            window.AlipayJSBridge.call('attach', { deviceId: mac, deviceChangeListener: deviceChangeListener }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'attachLazy',
        value: function attachLazy(mac, deviceChangeListener, callback) {
            document.container.addEventListener('onUplusReportLogicConnection', function (result) {
                var deviceId = result === null || result === void 0 ? void 0 : result.mac;
                var baseInfo = result === null || result === void 0 ? void 0 : result.baseInfo;
                if (mac === deviceId) {
                    deviceChangeListener(deviceId, baseInfo);
                }
            });
            document.container.addEventListener('onUplusReportLogicAttributes', function (result) {
                var deviceId = result === null || result === void 0 ? void 0 : result.mac;
                var baseInfo = result === null || result === void 0 ? void 0 : result.baseInfo;
                var attributes = result === null || result === void 0 ? void 0 : result.attributes;
                if (mac === deviceId) {
                    deviceChangeListener(deviceId, baseInfo, attributes);
                }
            });
            document.container.addEventListener('onUplusReportLogicCaution', function (result) {
                var deviceId = result === null || result === void 0 ? void 0 : result.mac;
                var baseInfo = result === null || result === void 0 ? void 0 : result.baseInfo;
                var attributes = result === null || result === void 0 ? void 0 : result.attributes;
                var cautions = result === null || result === void 0 ? void 0 : result.cautions;
                if (mac === deviceId) {
                    deviceChangeListener(deviceId, baseInfo, attributes, cautions);
                }
            });
            window.AlipayJSBridge.call('attachLazy', { deviceId: mac }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'detach',
        value: function detach(mac, callback) {
            window.AlipayJSBridge.call('detach', { deviceId: mac }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'calculate',
        value: function calculate(mac, name, value, isClear, callback) {
            var command = {
                name: name,
                value: value
            };
            window.AlipayJSBridge.call('calculate', { deviceId: mac, command: command, clear: isClear }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'calculateAll',
        value: function calculateAll(mac, commands, isClear, callback) {
            window.AlipayJSBridge.call('calculateAll', { deviceId: mac, commands: commands, clear: isClear }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'operate',
        value: function operate(mac, commands, callback) {
            window.AlipayJSBridge.call('operate', { deviceId: mac, commands: commands }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'startDeviceBusinessFunction',
        value: function startDeviceBusinessFunction(mac, name, clean, callback) {
            window.AlipayJSBridge.call('startDeviceBusinessFunction', { deviceId: mac, name: name, clean: clean }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'modifyBusinessFunction',
        value: function modifyBusinessFunction(mac, name, value, callback) {
            window.AlipayJSBridge.call('modifyBusinessFunction', { deviceId: mac, name: name, value: value }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'getBusinessFunctionCachedAttributes',
        value: function getBusinessFunctionCachedAttributes(mac, callback) {
            window.AlipayJSBridge.call('getBusinessFunctionCachedAttributes', { deviceId: mac }, this.generateCallbackFunc(callback, this.convertLeDeviceAttributeListFrom));
        }
    }, {
        key: 'getDeviceBusinessFunctionList',
        value: function getDeviceBusinessFunctionList(mac, callback) {
            window.AlipayJSBridge.call('getDeviceBusinessFunctionList', { deviceId: mac }, this.generateCallbackFunc(callback, this.convertBusinessAttrListFrom));
        }
    }, {
        key: 'executeBusinessFunction',
        value: function executeBusinessFunction(mac, callback) {
            window.AlipayJSBridge.call('executeBusinessFunction', { deviceId: mac }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'refreshAttributes',
        value: function refreshAttributes(mac, callback) {
            window.AlipayJSBridge.call('refreshAttributes', { deviceId: mac }, this.generateCallbackFunc(callback));
        }
    }]);

    return NebulaLogicenginePlugin;
}(NebulaPlugin);